<template>
  <BaseVeeForm
    :action="submit"
    ensure-error-keys-camel-case
    v-slot="{ isPending, invalid }"
    @success="showActions = false"
  >
    <ValidationProvider rules="required" name="mediaId" slim vid="mediaId">
      <template #default="{ errors }">
        <BaseFormInput type="hidden" :value="mediaId" />
        <BaseFormInlineMessage v-if="errors.length" danger>
          {{ errors[0] }}
        </BaseFormInlineMessage>
      </template>
    </ValidationProvider>
    <BaseButton primary small outline :disabled="isPending || invalid"> Delete </BaseButton>
  </BaseVeeForm>
</template>

<script>
import { accProductMediaClient } from '@/api/clients';

export default {
  inject: ['refreshAccProduct'],
  props: {
    accProductId: {
      type: String,
      required: true,
    },
    mediaId: {
      type: String,
      required: true,
    },
  },
  methods: {
    async submit() {
      try {
        await accProductMediaClient.destroy(this.accProductId, this.mediaId);
        await this.refreshAccProduct();

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
